// LoginPage.js
import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../AuthForm.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import e3logo from "../assets/e3logo.png";
import LoginProgress from "../component/LoginProgress";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "@mui/material/styles";

export default function LoginPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { dispatch } = useContext(AuthContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showLoginProgress, setShowLoginProgress] = useState(false);

  const handleLogIn = (e) => {
    e.preventDefault();
    setShowLoginProgress(true);
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen"
      style={{ backgroundColor: isDarkMode ? "#282A36" : "#f9fafb" }}
    >
      <div
        className="w-96 rounded-lg p-6 shadow-md text-center"
        style={{
          backgroundColor: isDarkMode ? "#1E1F29" : "white",
          color: isDarkMode ? "#F8F8F2" : "black",
        }}
      >
        {showLoginProgress ? (
          <LoginProgress
            username={username}
            password={password}
            dispatch={dispatch}
            navigate={navigate}
            setLoginSuccess={(val) => {
              if (val) {
                toast.success("Login Successful!");
                sessionStorage.setItem("loginState", "true");
                navigate("/dashboard");
              } else {
                // ❗ Exit login progress on failure
                console.log("Failed login in with active = 0");
                setShowLoginProgress(false);
              }
            }}
          />
        ) : (
          <>
            <img
              src={e3logo}
              alt="E3 Company Logo"
              className="w-20 mx-auto mb-4"
            />
            <h2 className="text-2xl font-bold mb-2">Log in to your account</h2>
            <p
              className="mb-4"
              style={{ color: isDarkMode ? "#BD93F9" : "#4B5563" }}
            >
              Welcome back! Please enter your details.
            </p>
            <div className="flex border border-gray-300 rounded-lg overflow-hidden mb-4">
              <Link
                to="/signup"
                className="flex-1 py-2 font-medium"
                style={{
                  color: isDarkMode ? "#BD93F9" : "#4B5563",
                  backgroundColor: isDarkMode ? "#282A36" : "#f3f4f6",
                }}
              >
                Sign up
              </Link>
              <Link
                to="/login"
                className="flex-1 py-2 font-medium"
                style={{
                  backgroundColor: isDarkMode ? "#44475A" : "white",
                  color: isDarkMode ? "#F8F8F2" : "black",
                }}
              >
                Log in
              </Link>
            </div>
            <form onSubmit={handleLogIn} className="space-y-2">
              <div className="mb-3">
                <label
                  htmlFor="username"
                  className="block font-medium"
                  style={{ color: isDarkMode ? "#F8F8F2" : "black" }}
                >
                  Username
                </label>
                <input
                  id="username"
                  placeholder="Enter Username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full border p-2 rounded-md focus:ring"
                  style={{
                    backgroundColor: isDarkMode ? "#44475A" : "white",
                    color: isDarkMode ? "#F8F8F2" : "black",
                    borderColor: isDarkMode ? "#BD93F9" : "#D1D5DB",
                  }}
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block font-medium"
                  style={{ color: isDarkMode ? "#F8F8F2" : "black" }}
                >
                  Password
                </label>
                <input
                  id="password"
                  placeholder="Enter Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border p-2 rounded-md focus:ring"
                  style={{
                    backgroundColor: isDarkMode ? "#44475A" : "white",
                    color: isDarkMode ? "#F8F8F2" : "black",
                    borderColor: isDarkMode ? "#BD93F9" : "#D1D5DB",
                  }}
                  required
                />
              </div>
              <div
                className="text-right text-sm cursor-pointer"
                style={{ color: isDarkMode ? "#BD93F9" : "#2563EB" }}
              >
                Forgot password?
              </div>
              <button
                type="submit"
                className="w-full py-2 rounded-md"
                style={{ backgroundColor: "#22C55E", color: "white" }}
              >
                Sign in
              </button>
              <button
                type="button"
                className="w-full border py-2 rounded-md"
                style={{
                  backgroundColor: isDarkMode ? "#44475A" : "white",
                  color: isDarkMode ? "#F8F8F2" : "black",
                }}
              >
                Continue with SSO
              </button>
            </form>
            <p className="mt-4 text-sm">
              Don&apos;t have an account?{" "}
              <Link
                to="/signup"
                style={{ color: isDarkMode ? "#BD93F9" : "#2563EB" }}
              >
                Sign up
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
